type EmailCallback = { kind: "none" } | { kind: "rejected" } | { kind: "code"; code: string };

const markers = new Set(["code", "error", "error_code", "error_description", "access_token", "refresh_token", "token_hash", "provider_token", "provider_refresh_token"]);
const supporting = new Set(["expires_at", "expires_in", "token_type"]);
const authTypes = new Set(["magiclink", "signup", "invite", "recovery", "email_change"]);

/** Consume only this page's callback, before an SDK can rewrite the URL.
 * Keep unrelated parameters (including duplicate values/encoding), anchors and
 * history state intact. Never persist/log callback values or accept URL sessions. */
export function takeDashboardEmailCallback(): EmailCallback {
  const query = window.location.search.slice(1);
  const hash = window.location.hash.slice(1);
  const parts = [query, hash];
  const parsed = parts.map((part) => new URLSearchParams(part));
  const hasCallback = parsed.map((params) => [...markers].some((key) => params.has(key)));
  if (!hasCallback.some(Boolean)) return { kind: "none" };

  const codes = parsed.flatMap((params) => params.getAll("code"));
  const invalid = parsed.some((params) => [...markers].some((key) => key !== "code" && params.has(key)));
  const cleaned = parts.map((part, index) => part.split("&").filter((segment) => {
    const parameter = new URLSearchParams(segment);
    const key = parameter.keys().next().value;
    return !key || !(markers.has(key) || hasCallback[index] && (supporting.has(key) || key === "type" && authTypes.has(parameter.get(key) ?? "")));
  }).join("&"));
  window.history.replaceState(window.history.state, "", `${window.location.pathname}${cleaned[0] ? `?${cleaned[0]}` : ""}${cleaned[1] ? `#${cleaned[1]}` : ""}`);
  const code = codes[0];
  if (invalid || codes.length !== 1 || !code || code.length > 4096 || /[\s\u0000-\u001f\u007f\ufffd]/.test(code)) return { kind: "rejected" };
  return { kind: "code", code };
}
